<script lang="ts">
import { TypographyTags } from '@/utils/accessibility';
import { BuilderComponent } from '@/utils/cms';
import { fonts } from '@/utils/typography';

export const Header4Registration: BuilderComponent = {
  name: 'Header4',
  canHaveChildren: true,
  defaultChildren: [
    {
      '@type': '@builder.io/sdk:Element',
      component: { name: 'Text', options: { text: 'Header 4 text here' } },
    },
  ],
  defaultStyles: {
    marginTop: '0px',
  },
};
</script>

<script setup lang="ts">
withDefaults(
  defineProps<{
    font?: 'sofia-pro' | 'gelica';
    headerTag?: TypographyTags;
  }>(),
  {
    font: 'sofia-pro',
    headerTag: 'h4',
  },
);
</script>

<template>
  <component
    :is="headerTag"
    class="text-xl font-semibold leading-6 lg:text-2xl lg:leading-7 header-4"
    :class="fonts[font]"
  >
    <slot />
  </component>
</template>

<style scoped>
.header-4 {
  @apply mb-0;
}
</style>
